<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索地图" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchMap } from '@/api/games/maps';



export default {
    name: "map-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchMap,
        }
    }
}
</script>
